// Libraries
import { action, computed, observable } from "mobx";
import "moment-timezone";

// Core
import { ModelBase } from "Core/Models/ModelBase";

export class PortalThemeModel extends ModelBase<PortalThemeModel, PortalThemeDto> {
    @observable public id = "";
    @observable public themeName = "";
    @observable public primaryColour = "";
    @observable public secondaryColour = "";
    @observable public portalLogoUrl = "";
    @observable public heroImageUrl = "";
    @observable public loginStrapLine = "";

    @action
    public fromDto = (portalThemeDto: PortalThemeDto) => {
        this.themeName = portalThemeDto.themeName;
        this.primaryColour = portalThemeDto.primaryColour;
        this.secondaryColour = portalThemeDto.secondaryColour;
        this.portalLogoUrl = portalThemeDto.portalLogoUrl;
        this.heroImageUrl = portalThemeDto.heroImageUrl;
        this.loginStrapLine = portalThemeDto.loginStrapLine;
    };

    @action
    public toDto = (): PortalThemeDto => {
        return {
            id: this.id,
            themeName: this.themeName,
            primaryColour: this.primaryColour,
            secondaryColour: this.secondaryColour,
            portalLogoUrl: this.portalLogoUrl,
            heroImageUrl: this.heroImageUrl,
            loginStrapLine: this.loginStrapLine,
        };
    };
}

export interface PortalThemeDto {
    id: string;
    themeName: string;
    primaryColour: string;
    secondaryColour: string;
    portalLogoUrl: string;
    heroImageUrl: string;
    loginStrapLine: string;
}
